import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldAlert } from "lucide-react";
import { trpc } from "@/lib/trpc";


export default function Unauthorized() {
    
    const logoutMutation = trpc.auth.logout.useMutation();

    const handleLogout = async () => {
        await logoutMutation.mutateAsync();
        window.location.href = "/";
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
                        <ShieldAlert className="h-8 w-8 text-red-600" />
                    </div>
                    <CardTitle className="text-2xl">存取被拒絕</CardTitle>
                    <CardDescription className="text-base mt-2">
                        您的電子郵件未獲授權存取此儀表板
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <p className="text-sm text-muted-foreground text-center">
                        請聯絡您的管理員以請求存取權限。
                    </p>
                    <Button
                        onClick={handleLogout}
                        className="w-full"
                        variant="outline"
                    >
                        登出
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
